// extracted by mini-css-extract-plugin
module.exports = {"container":"FilterSuggestions_container__B_UgF","title":"FilterSuggestions_title__dLK50"};